import type { TranslateOptions } from '../types';

/**
 * 创建异步翻译任务的能力
 */
export interface CreateAsyncTranslateTaskService {
    /**
     * 创建异步翻译任务
     * @param taskId 任务ID
     * @param translateOptions 翻译任务选项
     */
    createAsyncTranslateTask: (taskId: string, translateOptions: TranslateOptions) => Promise<void>;
}

export const CreateAsyncTranslateTaskService = Symbol('CreateAsyncTranslateTaskService');
